import Vue from 'expose-loader?Vue!vue';
import Resource from 'expose-loader?vue-resource!vue-resource';
import VueLoader from 'expose-loader?VueLoader!vue-loader';

import 'expose-loader?jQuery!jquery';
import 'expose-loader?$!jquery';



//var a = new Vue({}) ;
// not sure abut this yet...
